import { useState, useEffect } from "react";
import API from "../Services/API";
import { useSession } from "../Components/Session";

const usePreference = (key, def, session = false) => {
    const storage = session ? window.sessionStorage : window.localStorage;

    let existingVal = def;
    if (storage.getItem(key) !== null) {
        try {
            existingVal = JSON.parse(storage.getItem(key));
        } catch {
            existingVal = storage.getItem(key);
        }
    }
    const [value, setValue] = useState(existingVal);

    const set = (val) => {
        storage.setItem(key, JSON.stringify(val));
        setValue(val);
    }

    return [
        value,
        set,
    ];
}

const useSyncedPreference = (key, def = null) => {
    const {user} = useSession();
    const preferences = user?.appPreferences ?? null;

    const [isLoading, setIsLoading] = useState(preferences === null);
    const [value, setValue] = useState(preferences === null ? null : (preferences[key] ?? def));

    const set = (value) => {
        if (user?.appPreferences) {
            user.appPreferences[key] = value;
        }
        if (preferences) {
            preferences[key] = value;
        }
        setValue(value);
        API.post('/user/appPreferences', {preferences: {[key]: value}});
    }

    useEffect(() => {
        if (preferences === null) {
            return;
        }

        setIsLoading(false);
        if (preferences[key] === undefined) {
            set(def);
        } else {
            setValue(preferences[key]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preferences, key, def]);

    return [
        value,
        set,
        isLoading,
    ];
}

export {
    usePreference,
    useSyncedPreference,
}
